import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./ErrorType1.css";

const REASON_TEXTS = {
  recentAssessment: "You had a Home Energy Assessment less than 2 years ago.",
  paymentAssistance: "You're receiving discounted utility rates or assistance.",
  multiUnit: "Your home is in a multi‑unit building (5+ units).",
  fuelMunicipal: "Your heating fuel source and municipal electricity provider combination isn't supported.",
  condo: "Your home is in a condo association of 5+ units.",
  invalidZip: "Your zip code is not supported."
  // (Add more flags & messages here as needed)
};

const ErrorType1 = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const flags = state?.flags || [];
  const formData = state?.formData || null;

  // Turn each flag into a user‐facing message
  const reasons = flags.map((flag) => REASON_TEXTS[flag]).filter(Boolean);

  const handleBack = () => {
    // Save formData to localStorage if available
    if (formData) {
      localStorage.setItem("userInfo", JSON.stringify(formData));
      localStorage.setItem("resumeSurvey", "true");
    }
    navigate("/");
  };

  return (
    <div className="scheduler-container">
      {/* Top bar with company logo */}
      <div className="top-bar">
        <div className="logo">
          <img src="/colt-single-logo.png" alt="Colt Home Services" />
        </div>
      </div>

      <div className="error-card">
        <h2>Thank you for your interest</h2>
        {reasons.length > 0 ? (
          <>
            <p>Based on your answers, we can't provide an energy assessment right now for the following reason{reasons.length > 1 ? "s" : ""}:</p>
            <ul>
              {reasons.map((text, idx) => (
                <li class="reason" key={idx}>{text}</li>
              ))}
            </ul>
          </>
        ) : (
          <p>
            Based on the answers you provided, we aren't able to provide an energy assessment at this time.
            We will reach out if anything changes in the future.
          </p>
        )}
        <button className="home-button" onClick={handleBack}>
          Update Your Answers
        </button>
        <button
          className="home-button"
          style={{ marginTop: "1rem" }}
          onClick={() => window.location.href = "https://colthomeservices.com"}
        >
          Home
        </button>
      </div>
    </div>
  );
};

export default ErrorType1;
